import React, {useEffect, useCallback} from 'react'
import PropTypes from 'prop-types'
import Snackbar from '@material-ui/core/Snackbar'
import {makeStyles, withStyles} from '@material-ui/core/styles'
import {connect} from 'react-redux'
import {alertActions, userActions} from '../actions'

import classNames from 'classnames'
import {ReactComponent as ErrorIcon} from '../images/times.svg'
import {ReactComponent as InfoIcon} from '../images/info.svg'
import CloseIcon from '@material-ui/icons/Close'
import OKIcon from '@material-ui/icons/Check'
import {ReactComponent as CheckIcon} from '../images/check.svg'
import {ReactComponent as WarningIcon} from '../images/exclamation-triangle.svg'

import IconButton from '@material-ui/core/IconButton'
import SnackbarContent from '@material-ui/core/SnackbarContent'

const variantIcon = {
    success: CheckIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
}

const styles1 = theme => ({
    success: {
        //  opacity: 0.9,
        borderLeft: '5px solid',
        borderColor: theme.palette.success.borderColor,
        backgroundColor: theme.palette.success.secondary,
    },
    error: {
        //  opacity: 0.9,
        borderLeft: '5px solid',
        borderColor: theme.palette.error.borderColor,
        backgroundColor: theme.palette.error.secondary,
    },
    info: {
        //opacity: 0.9,
        borderLeft: '5px solid',
        borderColor: theme.palette.info.borderColor,
        backgroundColor: theme.palette.info.secondary,
    },
    warning: {
        //opacity: 0.9,
        borderLeft: '5px solid',
        borderColor: theme.palette.warning.borderColor,
        backgroundColor: theme.palette.warning.secondary,
    },
    icon: {
        fontSize: 20,
        color: '#000000',
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(2),
    },
    message: {
        display: 'flex',
        alignItems: 'center',
        color: '#000000',
        fontSize: 15,
        fontWeight: '600',
    },
})

function MySnackbarContent(props) {
    const {
        classes,
        className,
        message,
        onClose,
        variant,
        handleRefreshToken,
        ...other
    } = props
    const Icon = variantIcon[variant]

    const actionarray = []
    if (
        message ===
        'Session about to expire. You will be logged out in 1 minute. Extend session?'
    ) {
        actionarray.push(
            <IconButton
                key="refreshtoken"
                aria-label="Extend session"
                color="inherit"
                className={classes.close}
                onClick={handleRefreshToken}
            >
                <OKIcon className={classes.icon} />
            </IconButton>
        )
    } else {
        actionarray.push(
            <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                className={classes.close}
                onClick={onClose}
            >
                <CloseIcon className={classes.icon} />
            </IconButton>
        )
    }

    return (
        <SnackbarContent
            className={classNames(classes[variant], className)}
            aria-describedby="client-snackbar"
            message={
                <span id="client-snackbar" className={classes.message}>
                    <Icon
                        className={classNames(
                            classes.icon,
                            classes.iconVariant
                        )}
                    />
                    {message}
                </span>
            }
            action={actionarray}
            {...other}
        />
    )
}

MySnackbarContent.propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    message: PropTypes.node,
    onClose: PropTypes.func,
    variant: PropTypes.oneOf(['success', 'warning', 'error', 'info'])
        .isRequired,
}

const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent)

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    alertbar: {
        margin: theme.spacing(1),
        flexWrap: 'nowrap',
        [theme.breakpoints.down('xs')]: {
            width: '420px',
        },
    },
}))

function CustomizedSnackbars(props) {
    const classes = useStyles()
    const [open, setOpen] = React.useState(true)

    const {message, variant, clearalert, token, refreshtoken} = props

    const handleClose = useCallback(() => {
        setOpen(false)
        clearalert()
    }, [clearalert])

    const handleUserKeyPress = useCallback(
        event => {
            const {keyCode} = event

            if (keyCode === 'Enter') {
                handleClose()
            }
        },
        [handleClose]
    )

    const handleRefreshToken = useCallback(() => {
        setOpen(false)
        refreshtoken(token, false)
        clearalert()
    }, [clearalert, refreshtoken, token])

    // Add event listeners
    useEffect(() => {
        window.addEventListener('keydown', handleUserKeyPress)
        // Remove event listeners on cleanup
        return () => {
            window.removeEventListener('keydown', handleUserKeyPress)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) // Empty array ensures that effect is only run on mount and unmount

    return (
        <div className={classes.root}>
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                open={open}
                onClose={handleClose}
                autoHideDuration={null}
                key={new Date().getTime()}
            >
                <MySnackbarContentWrapper
                    variant={variant}
                    className={classes.alertbar}
                    message={message}
                    onClose={handleClose}
                    handleRefreshToken={handleRefreshToken}
                />
            </Snackbar>
        </div>
    )
}

CustomizedSnackbars.propTypes = {
    message: PropTypes.node,
    clearalert: PropTypes.func,
    variant: PropTypes.oneOf(['success', 'warning', 'error', 'info'])
        .isRequired,
}

function mapStateToProps(state) {
    return {
        token: state.authentication.token,
        alert: state.alert,
    }
}

const mapDispatchToProps = {
    clearalert: () => alertActions.clear(),
    refreshtoken: (token, noalertmsg) =>
        userActions.tokenrefresh(token, noalertmsg),
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomizedSnackbars)
